/**
 * Removes leading and/or trailing slashes from a given string based on the specified position.
 *
 * @param {string} input - The input string to strip slashes from.
 * @param {StripSlashPosition} [position='start-end'] - The position to strip slashes. Possible values are 'start', 'end', or 'start-end'.
 * @returns {string} The input string with leading and/or trailing slashes removed.
 */
export const stripSlash = (input, position = "start-end") => {
  let result = input;

  // Remove leading slashes
  while ((position === "start" || position === "start-end") && result.startsWith("/")) {
    result = result.slice(1);
  }

  // Remove trailing slashes
  while ((position === "end" || position === "start-end") && result.endsWith("/")) {
    result = result.slice(0, -1);
  }
  return result;
};